export default "/_next/static/images/4df2a46aff32649f66ce9f5c109c1a37.jpg";